<div class="big-button__wrapper" tabindex="0">
    {{label}}
</div>
